<script lang="ts">
  import FacetValueTags from "./FacetValueTags.svelte";
  import type { FacetValue } from "@otto-ec/heureka-components/facet-value";

  interface Props {
    values?: FacetValue[];
    rule?: string;
  }

  const { values = [], rule }: Props = $props();
</script>

<div class="hc_svelteFacetValueTagsWrapper" hidden>
  <FacetValueTags {values} {rule} />
</div>
